const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = new Map(); // regionCode -> { region, signLang, ttsLang, entries }

/**
 * loadDictionary — fetches /api/dictionary?region=X with in-memory caching.
 * Returns the full dictionary payload.
 */
export async function loadDictionary(regionCode) {
  const code = (regionCode || 'US').toUpperCase();
  if (cache.has(code)) return cache.get(code);
  const res = await fetch(`${API}/dictionary?region=${encodeURIComponent(code)}`);
  if (!res.ok) throw new Error(`dictionary ${code} status ${res.status}`);
  const data = await res.json();
  cache.set(code, data);
  return data;
}

export function clearDictionaryCache() {
  cache.clear();
}

/**
 * Given a dictionary's entries and a context mode, return the enabled entries.
 *   - general     → entries where contexts includes 'general'
 *   - hospitality → includes general + hospitality
 */
export function filterByContext(entries, contextMode) {
  if (!Array.isArray(entries)) return [];
  return entries.filter((e) => {
    const cs = e.contexts || ['general'];
    if (contextMode === 'hospitality') return cs.includes('general') || cs.includes('hospitality');
    return cs.includes('general');
  });
}

/**
 * Phase 4 — filter by ASL `category` ("all" | "everyday_basics" | "food_ordering").
 * Entries that don't carry `categories` default to "everyday_basics".
 */
export function filterByCategory(entries, category) {
  if (!Array.isArray(entries)) return [];
  if (!category || category === 'all') return entries;
  return entries.filter((e) => {
    const cats = e.categories?.length ? e.categories : ['everyday_basics'];
    return cats.includes(category);
  });
}
